import { ProxyServerProtocolEnum } from '@zaoblako/shared/modules/system/enums/proxy-server-protocol.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SystemDtoKeysEnum } from '@zaoblako/shared/modules/system/enums/system-dto-keys.enum';
import { IntergrationDtoKeyEnum } from '@zaoblako/shared/modules/integration/enums/intergration-dto-key.enum';
import type { TelegramBotFindInterface } from '@zaoblako/shared/modules/integration/dtos/telegram-bot/telegram-bot-find.dto';

import * as yup from 'yup';

/** Proxy server response body - DTO signature */
export interface ProxyServerFindInterface {
  /** Unique identifier (UUID). Cannot be changed. */
  id: string;

  // Tech columns
  /** Server creation date and time */
  created: Date;
  /** Server last update date and time */
  updated: Date;
  /** Server soft delete date and time */
  deleted?: Date;

  // Data columns
  /** Server display name */
  name: string;
  /** Server protocol */
  protocol: ProxyServerProtocolEnum;
  /** If `true` then this proxy-server will be used by AI-agents by default */
  aiAgentDefault?: boolean;
  /**
   * If `true` then server will use `https:` instead of `http:`.
   * Using only for proxy servers where {@link ProxyServerFindInterface.protocol}
   * equals {@link ProxyServerProtocolEnum.HTTPS}.
   */
  secured?: boolean;
  /** Server IP-address */
  host: string;
  /** Server net port number */
  port: number;
  /** Server user name to login */
  username: string;
  /** Server password to login */
  password: string;
  /** Telegram bots using this proxy server */
  telegramBots?: TelegramBotFindInterface[];
}

/** Proxy server response body - DTO schema */
export const ProxyServerFindDto = SerdeDtoClass.create<ProxyServerFindInterface>(SystemDtoKeysEnum.PROXY_SERVER_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.string(),
  },
  created: {
    sortable: true,
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Изменен',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удален',
    serializer: yup.date(),
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  protocol: {
    label: 'Протокол',
    serializer: yup
      .string()
      .oneOf(Object.values(ProxyServerProtocolEnum)),
  },
  secured: {
    optional: true,
    label: 'Защищенное соединение',
    serializer: yup.boolean(),
  },
  host: {
    sortable: true,
    label: 'IP-адрес',
    serializer: yup.string(),
  },
  port: {
    label: 'Порт',
    serializer: yup.number(),
  },
  username: {
    label: 'Логин',
    serializer: yup.string(),
  },
  password: {
    label: 'Пароль',
    serializer: yup.string(),
  },
  telegramBots: {
    optional: true,
    label: 'Боты Telegram, использующие этот прокси-сервер',
    nested: IntergrationDtoKeyEnum.TELEGRAM_BOT_FIND_DTO,
    serializer: (_, nested) => yup.array(nested),
  },
});
